// questions actions
export const SET_QUESTIONS = 'SET_QUESTIONS'
export const FILTER_QUESTIONS = 'FILTER_QUESTIONS'
export const GO_TO_NEXT_QUESTION = 'GO_TO_NEXT_QUESTION'
export const GO_TO_PREV_QUESTION = 'GO_TO_PREV_QUESTION'
export const RESET_QUESTIONS = 'RESET_QUESTIONS'

// responses actions
export const GENERATE_INITIAL_RESPONSES = 'GENERATE_INITIAL_RESPONSES'
export const ADD_ANSWERS = 'ADD_ANSWERS'
export const RESET_RESULTS = 'RESET_RESULTS'

// result actions
export const ADD_RESULT = 'ADD_RESULT'
export const UPDATE_RESULT_HAND = 'UPDATE_RESULT_HAND'

// products actions
export const SET_PRODUCTS = 'SET_PRODUCTS'
export const FILTER_PRODUCTS = 'FILTER_PRODUCTS'

// navigation actions
export const GO_TO_START_SCREEN = 'GO_TO_START_SCREEN'
export const GO_TO_QUESTIONS_SCREEN = 'GO_TO_QUESTIONS_SCREEN'
export const GO_TO_HAND_SCREEN = 'GO_TO_HAND_SCREEN'
export const GO_TO_DIGEST_SCREEN = 'GO_TO_DIGEST_SCREEN'

// ui actions
export const ADD_UI_STATE = 'ADD_UI_STATE'
